import React from "react";

import VisionSection from "./vision_section";
import DirectorProfile from "./director_profile";
import Mission from "./mission";
import ServicesSection from "./services_section";
import ImageGrid from "../../components/company_grid";
import Footer from "../../components/footer";
import HomeHeroSection from "./home_page";

function Home() {
  return (
    <div>
      <HomeHeroSection />
      <VisionSection />
      <Mission />
      <DirectorProfile />
      <ServicesSection />
      
      <ImageGrid />
      <Footer />
    </div>
  );
}

export default Home;
